import Deal from './Deal.page';

export default Deal;